import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "m-0" }
const _hoisted_3 = ["title"]
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.invite.name), 1),
      _createElementVNode("span", {
        class: "ml-2 badge badge-pill badge-secondary",
        title: _ctx.invite.code
      }, "Invited", 8, _hoisted_3),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-fill" }, null, -1)),
      _createElementVNode("button", {
        class: "btn btn-outline-secondary btn-icon btn-menu invite-copy",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyInviteLink && _ctx.copyInviteLink(...args))),
        title: "Copy invitation link"
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("i", { class: "fas fa-link" }, null, -1)
      ]))]),
      _createElementVNode("button", {
        class: "btn btn-outline-secondary btn-icon btn-menu invite-cancel",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelInvite && _ctx.cancelInvite(...args))),
        title: "Cancel invitation"
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
      ]))]),
      _createElementVNode("input", {
        hidden: "",
        type: "text",
        id: 'input-' + _ctx.invite.code
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("small", _hoisted_5, _toDisplayString(_ctx.invite.email), 1)
  ]))
}